module.exports = __webpack_public_path__ + "img/wave-background.ac33f5d3.svg";